var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    strokeWidth: 3
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.439 3.621H4.6a3.1 3.1 0 0 0-3.1 3.1v21.681a3.1 3.1 0 0 0 3.1 3.1h21.681a3.1 3.1 0 0 0 3.1-3.1V17.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.067 2.521a3 3 0 0 1 4.5 0 3.707 3.707 0 0 1 0 4.916L16.313 23.003l-6 1.639 1.5-6.555Z"
  }))));
};
export default SvgEdit;